import { INTERNAL_API_ROOT } from '../../config/api'
import { CALL_INTERNAL_API } from '../../middleware/authHeaders'

export const GET_ORGANIZATION_ROLES_DETAILS_REQUEST = 'GET_ORGANIZATION_ROLES_DETAILS_REQUEST'
export const GET_ORGANIZATION_ROLES_DETAILS_SUCCESS = 'GET_ORGANIZATION_ROLES_DETAILS_SUCCESS'
export const GET_ORGANIZATION_ROLES_DETAILS_FAILURE = 'GET_ORGANIZATION_ROLES_DETAILS_FAILURE'

export const getOrganizationRolesDetails = orgId => dispatch => {
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${orgId}/roles/permissions`,
      types: [
        GET_ORGANIZATION_ROLES_DETAILS_REQUEST,
        GET_ORGANIZATION_ROLES_DETAILS_SUCCESS,
        GET_ORGANIZATION_ROLES_DETAILS_FAILURE,
      ],
    },
  })
}

export const POST_ORGANIZATION_ROLES_DETAILS_REQUEST = 'POST_ORGANIZATION_ROLES_DETAILS_REQUEST'
export const POST_ORGANIZATION_ROLES_DETAILS_SUCCESS = 'POST_ORGANIZATION_ROLES_DETAILS_SUCCESS'
export const POST_ORGANIZATION_ROLES_DETAILS_FAILURE = 'POST_ORGANIZATION_ROLES_DETAILS_FAILURE'

export const postOrganizationRolesDetails = (orgGUID, payload) => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'POST',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${orgGUID}/roles`,
      types: [
        POST_ORGANIZATION_ROLES_DETAILS_REQUEST,
        POST_ORGANIZATION_ROLES_DETAILS_SUCCESS,
        POST_ORGANIZATION_ROLES_DETAILS_FAILURE,
      ],
      body: JSON.stringify(payload),
    },
  })
}

export const DELETE_ORGANIZATION_ROLES_REQUEST = 'DELETE_ORGANIZATION_ROLES_REQUEST'
export const DELETE_ORGANIZATION_ROLES_SUCCESS = 'DELETE_ORGANIZATION_ROLES_SUCCESS'
export const DELETE_ORGANIZATION_ROLES_FAILURE = 'DELETE_ORGANIZATION_ROLES_FAILURE'

export const deleteOrganizationRole = (orgGUID, roleId) => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'DELETE',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${orgGUID}/roles/${roleId}`,
      types: [
        DELETE_ORGANIZATION_ROLES_REQUEST,
        DELETE_ORGANIZATION_ROLES_SUCCESS,
        DELETE_ORGANIZATION_ROLES_FAILURE,
      ],
    },
  }).then(response => {
    if (!response?.error) {
      // Dispatch with roleId so reducer knows what to delete
      dispatch({
        type: DELETE_ORGANIZATION_ROLES_SUCCESS,
        payload: { id: roleId },
      })
    }
    return response
  })
}

export const UPDATE_ORGANIZATION_ROLES_REQUEST = 'UPDATE_ORGANIZATION_ROLES_REQUEST'
export const UPDATE_ORGANIZATION_ROLES_SUCCESS = 'UPDATE_ORGANIZATION_ROLES_SUCCESS'
export const UPDATE_ORGANIZATION_ROLES_FAILURE = 'UPDATE_ORGANIZATION_ROLES_FAILURE'

export const updateOrganizationRole = (orgGUID, roleId, payload) => dispatch => {
  return dispatch({
    [CALL_INTERNAL_API]: {
      method: 'PATCH',
      endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${orgGUID}/roles/${roleId}`,
      types: [
        UPDATE_ORGANIZATION_ROLES_REQUEST,
        UPDATE_ORGANIZATION_ROLES_SUCCESS,
        UPDATE_ORGANIZATION_ROLES_FAILURE,
      ],
      body: JSON.stringify(payload),
    },
  })
}

// Selectors
export const selectOrganizationRolesDetails = state => state.submittable.organizationRolesDetails
export const selectRoles = state =>
  selectOrganizationRolesDetails(state).organizationRolesDetails.organizationRolesDetailsData?.roles

// Sate
const INITIAL_STATE = {
  organizationRolesDetails: {
    organizationRolesDetailsData: null,
    isLoading: false,
    error: false,
  },
}

// REDUCERS
const organizationRolesDetails = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [GET_ORGANIZATION_ROLES_DETAILS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      organizationRolesDetails: {
        organizationRolesDetailsData: newPayload,
        isLoading: false,
        error: false,
      },
    }),
    [GET_ORGANIZATION_ROLES_DETAILS_REQUEST]: currentState => ({
      ...currentState,
      organizationRolesDetails: {
        ...currentState.organizationRolesDetails,
        isLoading: true,
        error: false,
      },
    }),
    [GET_ORGANIZATION_ROLES_DETAILS_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      organizationRolesDetails: {
        ...currentState.organizationRolesDetails,
        isLoading: false,
        error: {
          error: true,
          response: newPayload,
        },
      },
    }),
    [POST_ORGANIZATION_ROLES_DETAILS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      organizationRolesDetails: {
        organizationRolesDetailsData: {
          ...currentState.organizationRolesDetails.organizationRolesDetailsData,
          roles: [
            ...(currentState.organizationRolesDetails.organizationRolesDetailsData?.roles || []),
            newPayload,
          ],
        },
        isLoading: false,
        error: false,
      },
    }),
    [POST_ORGANIZATION_ROLES_DETAILS_REQUEST]: currentState => ({
      ...currentState,
      organizationRolesDetails: {
        ...currentState.organizationRolesDetails,
        isLoading: true,
        error: false,
      },
    }),
    [POST_ORGANIZATION_ROLES_DETAILS_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      organizationRolesDetails: {
        ...currentState.organizationRolesDetails,
        isLoading: false,
        error: {
          error: true,
          response: newPayload,
        },
      },
    }),
    [DELETE_ORGANIZATION_ROLES_REQUEST]: currentState => ({
      ...currentState,
      organizationRolesDetails: {
        ...currentState.organizationRolesDetails,
        isLoading: true,
        error: false,
      },
    }),
    [DELETE_ORGANIZATION_ROLES_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      organizationRolesDetails: {
        organizationRolesDetailsData: {
          ...currentState.organizationRolesDetails.organizationRolesDetailsData,
          roles: (
            currentState.organizationRolesDetails.organizationRolesDetailsData?.roles || []
          ).filter(role => role.id !== newPayload.id),
        },
        isLoading: false,
        error: false,
      },
    }),
    [DELETE_ORGANIZATION_ROLES_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      organizationRolesDetails: {
        ...currentState.organizationRolesDetails,
        isLoading: false,
        error: {
          error: true,
          response: newPayload,
        },
      },
    }),
    [UPDATE_ORGANIZATION_ROLES_REQUEST]: currentState => ({
      ...currentState,
      organizationRolesDetails: {
        ...currentState.organizationRolesDetails,
        isLoading: true,
        error: false,
      },
    }),
    [UPDATE_ORGANIZATION_ROLES_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      organizationRolesDetails: {
        organizationRolesDetailsData: {
          ...currentState.organizationRolesDetails.organizationRolesDetailsData,
          roles: (
            currentState.organizationRolesDetails.organizationRolesDetailsData?.roles || []
          ).map(role => (role.id === newPayload.id ? newPayload : role)),
        },
        isLoading: false,
        error: false,
      },
    }),
    [UPDATE_ORGANIZATION_ROLES_FAILURE]: (currentState, newPayload) => ({
      ...currentState,
      organizationRolesDetails: {
        ...currentState.organizationRolesDetails,
        isLoading: false,
        error: {
          error: true,
          response: newPayload,
        },
      },
    }),
  }[type]?.(state, payload) || state)

export default organizationRolesDetails
